import { config } from "@/config";
import { useApi } from "@/hooks/use-api";
import { useAppDispatch } from "@/store/useApp";
import * as Frigade from "@frigade/react";
import { useFlow } from "@frigade/react";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingAnnouncementFlow = () => {
  const { flow } = useFlow(config.frigade.flows.homeAnnouncement);
  const { deleteOnboarding } = useApi();
  const dispatch = useAppDispatch();

  const handleDismiss = async () => {
    await deleteOnboarding();
  };

  const handlePrimary = async () => {
    dispatch({ type: "START_ONBOARDING" });
  };

  if (flow && !flow.isCompleted) {
    return (
      <OnboardingFlow>
        <Frigade.Announcement
          flowId={config.frigade.flows.homeAnnouncement}
          dismissible={true}
          onPrimary={handlePrimary}
          onSecondary={handleDismiss}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingAnnouncementFlow;
